module.exports = __webpack_public_path__ + "img/cost-assist.82397db9.svg";